import InputMask from 'react-input-mask'

import { FormControl, FormErrorMessage, Input } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import axios from 'axios'

import { ArrowForwardIcon } from '@chakra-ui/icons'

import Layout from 'components/Layout/Default'
import Container from 'components/Container'

import * as S from './styles'
import { useState } from 'react'
import { useRouter } from 'next/router'
import Loading from 'pages/components/Loading'

export function transformarParaUrlAmigavel(str) {
  // remover acentos, espaços e caracteres especiais
  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  str = str.replace(/[^a-zA-Z0-9 ]/g, '')

  // converter para minúsculas e substituir espaços por hifens
  str = str.toLowerCase().replace(/\s+/g, '-')

  return str
}

const Contato = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const router = useRouter()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const onSubmit = async (payload) => {
    setLoading(true)
    try {
      const { data } = await axios.get(
        `https://viacep.com.br/ws/${payload.cep}/json/`
      )
      setSuccess(true)
      setError(false)

      window?.scrollTo(0, 0)
      router.push(
        `/comprar-grama/${transformarParaUrlAmigavel(
          data.uf
        )}/${transformarParaUrlAmigavel(data.localidade)}`
      )
    } catch (error) {
      setError(true)
      setSuccess(false)
      setTimeout(() => {
        setError(false)
        setSuccess(false)
      }, 3000)
    } finally {
      setLoading(false)
    }
  }

  const cepRef = register('cep')

  const handleCepChange = (e) => {
    cepRef?.onChange(e)
  }

  return (
    <Layout
      category="Orçamento Rápido"
      title="Comprar Grama para sua cidade"
      description="Compre grama direto do produtor para todo o Brasil, basta informar o seu CEP que abrirá automaticamente o formulário de orçamento, prazo de retorno são 24 horas úteis..."
      keywords="comprar grama, comprar grama sp, comprar grama rj, comprar grama mg, comprar grama es, comprar grama pr, comprar grama sc, comprar grama rs, comprar grama go, comprar grama mt, comprar grama ms, comprar grama df, comprar grama ba"
      categorySize="1.6rem"
    >
      <section>
        <Loading isLoading={loading} />
        <Container>
          <S.Flex>
            <S.Left>
              <h3>Qual é o CEP de onde você quer comprar grama?</h3>
              <S.Form onSubmit={handleSubmit(onSubmit)}>
                <S.Grid gap="24px">
                  <FormControl isInvalid={errors.cep}>
                    <InputMask
                      mask="99999-999"
                      maskChar=""
                      onChange={handleCepChange}
                      value={cepRef.value}
                      {...register('cep', {
                        required: 'Este campo é obrigatório',
                      })}
                    >
                      {() => <Input type="tel" placeholder="Cep" name="cep" />}
                    </InputMask>
                    <FormErrorMessage>
                      {errors.cep && errors.cep.message}
                    </FormErrorMessage>
                  </FormControl>
                </S.Grid>
                <S.Button
                  disabled={loading}
                  shape="rounded"
                  title="comprar grama para o meu cep"
                >
                  Pŕoximo passo <ArrowForwardIcon w={4} h={4} />
                </S.Button>
              </S.Form>
            </S.Left>
          </S.Flex>
        </Container>
      </section>
    </Layout>
  )
}

export default Contato
